import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-svg-sprites',
    templateUrl: './svg-sprites.component.html',
    styleUrls: ['./svg-sprites.component.scss']
})
export class SvgSpritesComponent implements OnInit {

  @Input() href

  @Input() width = 30

  @Input() height = 30

  @Input() alt

  @Input() class

  constructor() { }

  ngOnInit() { 
  }

}
